module.exports = __webpack_public_path__ + "static/media/hollow_bar_finalinspect.2f94b632.svg";